import { Subject } from 'rxjs';
var ApDialogRef = /** @class */ (function () {
    function ApDialogRef(ref, overlay) {
        this.ref = ref;
        this.overlay = overlay;
    }
    Object.defineProperty(ApDialogRef.prototype, "componentInstance", {
        get: function () {
            return !!this.ref.component ? this.ref.component.instance : undefined;
        },
        enumerable: true,
        configurable: true
    });
    ApDialogRef.prototype.close = function () {
        this.overlay.detach();
        this.overlay.dispose();
        if (this._afterClosed) {
            this._afterClosed.next(this.ref);
            this._afterClosed.complete();
        }
    };
    ApDialogRef.prototype.afterClosed = function () {
        if (!this._afterClosed) {
            this._afterClosed = new Subject();
        }
        return this._afterClosed.asObservable();
    };
    return ApDialogRef;
}());
export { ApDialogRef };
